module.exports = {"150171400":"金海开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150171.json
// module id = 400
// module chunks = 0